import React from 'react';
import { PageHeading } from 'components/page-heading';
import { SolarExplainer } from 'pages/solar/components/solar-explainer';
import { Grid, LeftColumnGridCell, RightColumnGridCell } from 'styles';
import { AdvocacyModule } from 'pages/solar/components/advocacy-module';
import { ReconnectUtilityNotification } from 'pages/solar/components/reconnect-utility-notification';

export const Unavailable = ({
  advocacyCampaign,
  completedAdvocacyCampaign,
  hasAdvocacyCampaignSubmission,
  pageHeading,
  stateAbbreviation,
  stateFullName,
  utilityAccountId,
}: SolarActiveViewProps) => {
  return (
    <>
      <PageHeading page={pageHeading} />
      <ReconnectUtilityNotification />
      <Grid width="100%" gap="24px">
        <LeftColumnGridCell>
          <SolarExplainer />
        </LeftColumnGridCell>
        <RightColumnGridCell>
          <AdvocacyModule
            advocacyCampaign={advocacyCampaign}
            completedAdvocacyCampaign={completedAdvocacyCampaign}
            hasAdvocacyCampaignSubmission={hasAdvocacyCampaignSubmission}
            stateAbbreviation={stateAbbreviation}
            stateFullName={stateFullName}
            utilityAccountId={utilityAccountId}
          />
        </RightColumnGridCell>
      </Grid>
    </>
  );
};
